import React from 'react'
import DataSource from '../DataSource'
import Tab from '../components/Tab'
import Heading from '../components/Heading'
import ResponsiveTable from '../components/ResponsiveTable'
import ExpandableListModule from '../modules/ExpandableListModule'
import { gsap } from 'gsap'
import CountrySearch from '../components/CountrySearch'
import globals from '../globals'
import FaqStructuredData from '../components/FaqStructuredData'

class MobileRoaming extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            title: '',
            description: [],
            rates: { zone1: {}, zone2: {}, zone3: {}, zone4: {} },
            thingsToKnow: [],
            // USER INPUT
            search: '',
            countryList: [],
            currentCountry: {}
        }

        this.noResults = [{ zone: 'no-results', country: 'No country found.', additional: '' }]
        this.legend = {
            '*': 'Data roaming is not yet available in this country',
            1: 'Requires a 3G 850/1900 handset for 3G Roaming',
            2: 'Requires a GSM 1900MHz compatible (tri-band) handset',
            3: 'Requires a 3G 2100MHz compatible handset',
            4: 'Requires a GSM 850MHz compatible (quad-band) handset',
            5: 'Note: T-Mobile USA requires a 1700/2100MHz handset for 3G roaming'
        }
    }

    componentDidMount () {
        DataSource.getData('/api/getContent/mobile/roaming', response => {
            this.setState({
                ...response,
                isLoaded: true
            })
        })
        globals.pushGA4Events("pageLoad", {
            eventInfo: {
                pageName: "Mobile roaming",
                pageCategory: "Mobile",
                pageType: "Information"
            }
        });
    }

    handleChange (event) {
        this.setState({ search: event.target.value }, this.getCountries.bind(this))
    }

    handleSelect (event, data, inputEl) {
        event.preventDefault()

        if (data.zone === 'no-results') {
            inputEl.current.select()
        } else {
            this.setState({
                countryList: [],
                search: data.country
            })

            this.animateTableOut()

            setTimeout(() => {
                this.setState({
                    currentCountry: data
                }, this.animateTableIn.bind(this))
            }, 250)
        }
    }

    resetCountries () {
	    this.setState({
            search: '',
            countryList: '',
            currentCountry: {}
        })
    }

    animateTableOut () {
        gsap.to(this.tableWrapper, 0.25, { opacity: 0 })
    }

    animateTableIn () {
        gsap.to(this.tableWrapper, 0.25, { opacity: 1 })
    }

    getCountries () {
        if (this.state.search.length > 2) {
            clearTimeout(this.timer)

            this.timer = setTimeout(() => {
                globals.pushEvent('gtm-Mobile-Global-Roaming-Rate-Search')
                DataSource.getData(`/api/searchRoamingCountries/${this.state.search}`, result => {
                    if (result.length > 0) {
                        this.setState({ countryList: result })
                    } else {
                        this.setState({ countryList: this.noResults })
                    }
                })
            }, 500)
        }
    }

    getClassName () {
        if (this.state.currentCountry.zone) {
            const zone = this.state.currentCountry.zone
            if (zone === 1) {
                return 'hide-zone2 hide-zone3 hide-zone4'
            } else if (zone === 2) {
                return 'hide-zone1 hide-zone3 hide-zone4'
            } else if (zone === 3) {
                return 'hide-zone1 hide-zone2 hide-zone4'
            } else {
			    return 'hide-zone1 hide-zone2 hide-zone3'
            }
        }

        return ''
    }

    render () {
	    const Note = <p className='m-0 mt-2 font-tiny'>Note: for information purposes - subject to updates (additions, changes and/or deletions)</p>

        return (
            <React.Fragment>
                <FaqStructuredData faqs={this.state.thingsToKnow} />
                <Tab isLoaded={this.state.isLoaded} className={`mobile-roaming ${this.getClassName()}`}>
                    <Heading title={this.state.title} className='text-center mb-0' />
                    <div className='row mb-5'>
                        <div className='col-12 col-lg-8 offset-lg-2'>
                            <div className='mb-5'>
                                {this.state.description.map((item, key) => {
                                    return <p key={key} dangerouslySetInnerHTML={{ __html: globals.noWidows(item) }} />
                                })}
                            </div>

                            <CountrySearch
                                title='Find your zone:'
                                countryList={this.state.countryList}
                                search={this.state.search}
                                handleChange={this.handleChange.bind(this)}
                                handleSelect={this.handleSelect.bind(this)}
                                handleCancel={this.resetCountries.bind(this)}
                            />

                            {this.state.currentCountry.country
                                ? <div className='row mb-4'>
                                    <div className='col-12 col-lg-4 offset-lg-4 text-center country-wrap'>
                                        <h5 className='m-0 mb-1 bold'>
                                            {this.state.currentCountry.country.trim()}
                                        </h5>
                                        <h5 className='m-0 mb-1 bold'>Zone: {this.state.currentCountry.zone}</h5>
                                        <p className='m-0 font-small text-center'>
                                            {this.state.currentCountry.type === 'N' ? 'Preferred network operator' : 'Non preferred network operator'}<br />
                                            MCC: {this.state.currentCountry.mcc}<span className='bold'> | </span>
                                            MNC: {this.state.currentCountry.mnc}
                                        </p>
                                    </div>
                                  </div>
                                : ''}

                            <div ref={el => this.tableWrapper = el}>
                                <div className='mb-5 zone-1'>
                                    <p className='m-0 mb-2 bold text-center'>Zone 1 rates</p>
                                    <ResponsiveTable data={this.state.rates.zone1} />
                                    {Note}
                                </div>
                                <div className='mb-5 zone-2'>
                                    <p className='m-0 mb-2 bold text-center'>Zone 2 rates</p>
                                    <ResponsiveTable data={this.state.rates.zone2} />
                                    {Note}
                                </div>
                                <div className='mb-5 zone-3'>
                                    <p className='m-0 mb-2 bold text-center'>Zone 3 rates</p>
                                    <ResponsiveTable data={this.state.rates.zone3} />
                                    {Note}
                                </div>
                                <div className='zone-4'>
                                    <p className='m-0 mb-2 bold text-center'>Zone 4 rates</p>
                                    <ResponsiveTable data={this.state.rates.zone4} />
                                    {Note}
                                </div>
                            </div>

                        </div>
                    </div>
                    <ExpandableListModule data={this.state.thingsToKnow} title='Things you need to know' />
                </Tab>
            </React.Fragment>
        )
    }
}

export default MobileRoaming



// WEBPACK FOOTER //
// ./resources/js/mobile/MobileRoaming.js